import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Router from './../core/router';

import Home from './components/pages/home';
import Contacto from './components/pages/contacto';
import Cursos from './components/pages/cursos';
import CursosDeGrado from './components/pages/cursosDeGrado';
import CursosDePostGrado from './components/pages/cursosDePostGrado';
import Investigacion from './components/pages/investigacion';
import Integrantes from './components/pages/integrantes';
import Ensenanza from './components/pages/ensenanza';
import PropuestasDeTesis from './components/pages/propuestasDeTesis';
import Tutorias from './components/pages/tutorias';
import Integrante from './components/pages/integrante';
import Actividades from './components/pages/actividades';
import About from './components/pages/about';
import SeminarioCharla from './components/pages/seminarioCharla';
import Carreras from './components/pages/carreras';
import Curso from './components/pages/Curso';
import Carrera from './components/pages/Carrera';
import Plan from './components/pages/Plan';
import router from './../core/router';
import PaginaDePoliticasDePrivasidad from './components/pages/politicasDePrivasidad';
import SuccessPage from './components/pages/contactSuccessPage';

const rootComponent = () => (
  <BrowserRouter basename={process.env.PUBLIC_URL}>
    <Routes>
      <Route
        path={router.successEnvioDeFormulario}
        element={<SuccessPage />}
      ></Route>
      <Route
        path={router.politicasDePrivacidadYProteccionDeDatos}
        element={
          <PaginaDePoliticasDePrivasidad
            pageData={{
              title: 'Políticas de privacidad y protección de datos | GrIS',
              description:
                'En esta página se describen las políticas de privacidad y protección de datos del grupo de ingeniería de software',
            }}
          />
        }
      />
      <Route path={Router.plan} element={<Plan />}>
        {' '}
      </Route>
      <Route path={Router.carrera} element={<Carrera />}>
        {' '}
      </Route>
      <Route path={Router.curso} element={<Curso />}>
        {' '}
      </Route>
      <Route
        path={Router.carreras}
        element={
          <Carreras
            pageData={{
              title: 'Carreras del grupo de Ingeniería de Software | GrIS',
              description:
                'En esta página se describen las carreras del grupo de ingeniería de software',
            }}
          />
        }
      >
        {' '}
      </Route>
      <Route
        path={Router.about}
        element={
          <About
            pageData={{
              title: 'Sobre el grupo de Ingeniería de Software | GrIS',
              description:
                'Quienes somos y que hacemos, todo sobre el grupo de ingeniería de software GrIS',
            }}
          />
        }
      >
        {' '}
      </Route>
      <Route
        path={Router.home}
        element={
          <Home
            pageData={{
              title: 'Grupo de Ingeniería de Software | GrIS',
              description:
                'El GrIS es un grupo de investigación en Ingeniería de Software de la Facultad de Ingeniería de la Universidad de la República',
            }}
          />
        }
      >
        {' '}
      </Route>
      <Route
        path={Router.contacto}
        element={
          <Contacto
            pageData={{
              title: 'Contacto',
              description:
                'Medios de contacto con el grupo de ingeniería de software',
            }}
          />
        }
      >
        {' '}
      </Route>

      <Route
        path={Router.cursosDeGrado}
        element={
          <CursosDeGrado
            pageData={{
              title: 'Cursos de grado',
              description:
                'Lista de cursos de grado del grupo de ingeniería de software',
            }}
          />
        }
      >
        {' '}
      </Route>
      <Route
        path={Router.cursosDePostGrado}
        element={
          <CursosDePostGrado
            pageData={{
              title: 'Cursos de post grado',
              description:
                'Todos los cursos de post grado del grupo de ingeniería de software',
            }}
          />
        }
      >
        {' '}
      </Route>
      <Route
        path={Router.investigacion}
        element={
          <Investigacion
            pageData={{
              title: 'Investigación ',
              description:
                'La investigación del grupo de ingeniería de software, sus miembros y proyectos, artículos y publicaciones.',
            }}
          />
        }
      >
        {' '}
      </Route>
      <Route
        path={Router.integrantes}
        element={
          <Integrantes
            pageData={{
              title: 'Integrantes',
              description:
                'Quienes integran el grupo de ingeniería de software',
            }}
          />
        }
      >
        {' '}
      </Route>

      <Route path={Router.integrante} element={<Integrante />}>
        {' '}
      </Route>

      <Route path={Router.charlaSeminario} element={<SeminarioCharla />}>
        {' '}
      </Route>

      <Route
        path={Router.ensenanza}
        element={
          <Ensenanza
            pageData={{
              title: 'Enseñanza',
              description: 'Descripción del grupo',
            }}
          />
        }
      ></Route>
      <Route
        path={Router.cursos}
        element={
          <Cursos
            pageData={{
              title:
                'Cursos de grado y posgrado. Grupo de ingeniería de Software',
              description:
                'Listado de cursos de grado y posgrado del grupo de ingeniería de software',
            }}
          />
        }
      >
        {' '}
      </Route>
      <Route
        path={Router.propuestasDeTesis}
        element={
          <PropuestasDeTesis
            pageData={{
              title: 'Propuesta de tesis',
              description:
                'Las propuestas de tesis del grupo de ingeniería de software',
            }}
          />
        }
      >
        {' '}
      </Route>
      <Route
        path={Router.tutorias}
        element={
          <Tutorias
            pageData={{
              title: 'Tutorias',
              description:
                'Asesoramiento y tutorias del grupo de ingeniería de software',
            }}
          />
        }
      >
        {' '}
      </Route>
      <Route
        path={Router.actividades}
        element={
          <Actividades
            pageData={{
              title: 'Actividades',
              description:
                'Cuáles son las actividades del grupo de ingeniería de software',
            }}
          />
        }
      >
        {' '}
      </Route>
    </Routes>
  </BrowserRouter>
);

export default rootComponent;
